module.exports = __webpack_public_path__ + "img/two-lines-light.e9e8be97.png";